module.exports = __webpack_public_path__ + "img/advantage7.f70ade18.png";